const summary_cards = [
  { label: 'Licences tracked', value: '7', note: 'Permits & certs', accent: 'dark' },
  { label: 'Valid', value: '2', note: 'Current', accent: 'green' },
  { label: 'Renewal due / expiring', value: '3', note: 'Action soon', accent: 'amber' },
  { label: 'Expired', value: '2', note: 'Operating at risk', accent: 'red' }
];

const filters = [
  { id: 'all', label: 'All', count: 7, active: true },
  { id: 'operating', label: 'Operating', count: 3 },
  { id: 'facility', label: 'Facility', count: 3 },
  { id: 'software', label: 'Software', count: 1 }
];

const rows_by_tab = {
  all: [
    { ref: 'LP-01', licence: 'Fire safety certificate', holder: 'Soweto clinic', expiry: '02 Apr 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'LP-02', licence: 'Business licence', holder: 'Head office', expiry: '31 Dec 2026', status: { label: 'Valid', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'LP-03', licence: 'Microsoft 365 E5 (240 seats)', holder: 'IT department', expiry: '31 Aug 2026', status: { label: 'Renewal due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'LP-04', licence: 'Health facility licence', holder: 'Soweto clinic', expiry: '30 Sep 2026', status: { label: 'Valid', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'LP-05', licence: 'Professional registrations - nurses (12)', holder: 'Soweto clinic', expiry: 'Various', status: { label: 'Action needed', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'LP-06', licence: 'Hazardous waste handling permit', holder: 'Central warehouse', expiry: '15 Jul 2026', status: { label: 'Expiring', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'LP-07', licence: 'Training provider accreditation (SETA)', holder: 'Skillsforce (provider)', expiry: '31 May 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } }
  ],
  operating: [
    { ref: 'LP-01', licence: 'Fire safety certificate', holder: 'Soweto clinic', expiry: '02 Apr 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'LP-02', licence: 'Business licence', holder: 'Head office', expiry: '31 Dec 2026', status: { label: 'Valid', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'LP-07', licence: 'Training provider accreditation (SETA)', holder: 'Skillsforce (provider)', expiry: '31 May 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } }
  ],
  facility: [
    { ref: 'LP-01', licence: 'Fire safety certificate', holder: 'Soweto clinic', expiry: '02 Apr 2026', status: { label: 'Expired', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'LP-04', licence: 'Health facility licence', holder: 'Soweto clinic', expiry: '30 Sep 2026', status: { label: 'Valid', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'LP-06', licence: 'Hazardous waste handling permit', holder: 'Central warehouse', expiry: '15 Jul 2026', status: { label: 'Expiring', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  software: [
    { ref: 'LP-03', licence: 'Microsoft 365 E5 (240 seats)', holder: 'IT department', expiry: '31 Aug 2026', status: { label: 'Renewal due', class: 'bg-warning-subtle text-warning-emphasis' } }
  ]
};

export default {
  name: 'ComplyonLicencesPermitsCertifications',
  data: () => ({
    summary_cards,
    filters,
    active_tab: 'all',
    rows_by_tab
  }),
  computed: {
    rows() {
      return this.rows_by_tab[this.active_tab] || this.rows_by_tab.all;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};
